import {Localizer} from "../../../infrastructure/localization/localizer";
import React from "react";
import {EmblaIcon} from "../../../core/components/emblaIcon/emblaIcon";
import {EmblaIcons} from "../../../core/emblaIcons";
import {RoutePaths} from "../../../infrastructure/routes";
import {useHistory} from "react-router-dom";

type VejlederCellProps = {
    vejledername: string;
}
export const VejlederCell = ({vejledername}: VejlederCellProps) => {
    const history = useHistory();

    return (
        <>
            {vejledername !== Localizer.dashboard_tildelVejleder() ?
                vejledername
                :
                <div
                    className="flex-align-c badge badge-danger-light badge-pill padding-xs"
                    style={{cursor: "pointer"}}
                    onClick={() => history.push(RoutePaths.Vejledere.url)}>
                    <div className={"flex-center margin-right-xs"}>
                        <EmblaIcon iconName={EmblaIcons.Danger} additionalClasses={"margin-right-xs danger"}
                                   size={"medium"}/>
                        <b className={"danger-dark"}>
                            {Localizer.dashboard_tildelVejleder()}
                        </b>
                    </div>
                </div>
            }
        </>
    );
};
